import {Component, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {Page} from '../../../../global/util/enum/Page';
import {InformType} from '../../../../global/util/enum/InformType';
import {ModalDismissReasons, NgbDateParserFormatter, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Constant} from '../../../../global/util/Constant';
import {DocumentService} from '../../../service/document.service';
import {AddDocumentBatchComponent} from '../add-document-batch/add-document-batch.component';
import {SignService} from '../../../service/sign.service';
import {ReviewDocumentComponent} from '../review-document/review-document.component';
import {AddDocumentOneComponent} from '../add-document-one/add-document-one.component';
import {DocumentUtil} from '../../../../global/util/DocumentUtil';
import {AuthService} from '../../../service/auth/auth.service';
import {ApplicationService} from '../../../service/application.service';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import {NotificationService} from '../../../service/notification.service';
import {DocumentState} from '../../../../global/util/DocumentState';
import {StringUtil} from '../../../../global/util/StringUtil';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {PersonService} from '../../../service/person.service';
import {ViewParticipantComponent} from '../view-participant/view-participant.component';
import {ConfirmComponent} from '../../../../shared/confirm/confirm.component';
import {Response} from '../../../../global/util/enum/Response';
import {Stampdatetime} from '../../../model/Stampdatetime';
import {State} from '../../../model/State';
import {CloneTool} from '../../../../global/util/CloneTool';
import {AddDocumentOneDynamicComponent} from '../add-document-one-dynamic/add-document-one-dynamic.component';
import {ReasignParticipantComponent} from '../reasign-participant/reasign-participant.component';
import {CancelDocumentComponent} from '../cancel-document/cancel-document.component';
import {ViewObservationCancelComponent} from '../view-observation-cancel/view-observation-cancel.component';
import {Observationcancel} from '../../../model/Observationcancel';
import {Workflow} from '../../../model/Workflow';
import {SignType} from '../../../../global/util/enum/SignType';
import {Router} from '@angular/router';
import {ViewDocumentComponent} from '../view-document/view-document.component';
import {Person} from '../../../model/Person';
import {ReviewType} from '../../../../global/util/enum/ReviewType';
import {Dialog} from '../../../../global/util/Dialog';
import {SendToEmailComponent} from '../send-to-email/send-to-email.component';
import {MailtemplateService} from '../../../service/mailtemplate.service';
import {Mailtemplate} from '../../../model/Mailtemplate';
import {SignDocumentInternalComponent} from '../sign-document-internal/sign-document-internal.component';
import {Document} from '../../../model/Document';
import {FinalizeDocumentComponent} from '../finalize-document/finalize-document.component';
import {TypeSignature} from '../../../../global/util/TypeSignature';
import {UanatacaRequest} from '../../../model/UanatacaRequest';
import {UanatacaService} from '../../../service/uanataca.service';
import {AddEditPersonComponent} from '../../person/add-edit-person/add-edit-person.component';
import {SearchDocument} from '../../../model/search/SearchDocument';
import {NgbDateStructUtil} from '../../../../global/util/NgbDateStructUtil';
import {CustomDateParserFormatter} from '../../balance/view-balance/view-balance.component';
import {Partner} from '../../../model/Partner';
import {Enterprise} from '../../../model/Enterprise';
import {StateSolcert} from '../../../../global/util/validator/StateSolcert';
import {TranslateService} from '@ngx-translate/core';
import {ViewDocumentDetailComponent} from '../view-document-detail/view-document-detail.component';
import {AddDocumentNotifyBatchComponent} from '../add-document-notify-batch/add-document-notify-batch.component';
import {WorkflowType} from '../../../../global/util/WorkflowType';
import {EnterpriseStorageService} from '../../../service/enterprise-storage.service';
import {EnterpriseStorage} from 'src/app/user/model/EnterpriseStorage';
import {ConvertBytes} from '../../../../global/util/ConvertBytes';
import {Pagination} from '../../../../global/util/Pagination';
import {PublicService} from '../../../service/public.service';
import {
  AcceptTermsConditionsComponent
} from '../../../../shared/accept-terms-conditions/accept-terms-conditions.component';
import {GeolocationService} from '../../../service/geolocation.service';
import {TypeAlert} from '../../../../global/util/TypeAlert';
import {ShowCopyUrlComponent} from '../show-copy-url/show-copy-url.component';
import {ShowForwardUrlComponent} from '../show-forward-url/show-forward-url.component';
import {GeolocationIofesign} from '../../../model/GeolocationIofesign';
import {WorkflowService} from '../../../service/workflow.service';
import {WorkflowDataService} from '../../../service/data/workflow-data.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@Component({
  selector: 'app-list-document',
  templateUrl: './list-document.component.html',
  styleUrls: ['./list-document.component.css'],
  providers: [{provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter}]
})
export class ListDocumentComponent implements OnInit, OnDestroy {

  public documents: any[] = [];
  public page: any = {};
  public links: any = {};
  private documentUrl: string;
  public enumPage = Page;
  public loading: boolean;
  private entityName = 'TITLE.DOCUMENT';
  public title = 'TITLE.DOCUMENTS';
  private selectedDocuments: any[] = [];
  public checkedShowAllOption = false;
  private interval: any;
  private storageInterval: any;
  public calledOfAutorefresh = false;
  public loadingSign = false;
  public loadingSave = false;
  public loadingDownload = false;
  public loadingShowBy = false;
  public loadingAttend = false;
  private personId;
  public partners: Partner[] = [];
  public partnerSelected: Partner;
  public enterprises: Enterprise[] = [];
  public enterpriseIdSelected: number;
  public enterpriseSelected: Enterprise;
  public workflows: Workflow[] = [];
  public workflowSelected: any;
  public workflowIdSelected: number;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public ROLE_ADMIN = Constant.ROLE_ADMIN;
  public ROLE_LITE_ADMIN = Constant.ROLE_LITE_ADMIN;
  public ROLE_USER = Constant.ROLE_USER;
  public ROLE_ASSISTANT = Constant.ROLE_ASSISTANT;
  public ROLE_LITE_ASSISTANT = Constant.ROLE_LITE_ASSISTANT;
  public ROLE_SUPERVISOR = Constant.ROLE_SUPERVISOR;
  public loadingCopyClipboard = false;
  public subject: string;
  public officialSubject: string;
  public searchFilters: SearchDocument = new SearchDocument();
  public showAdditionalFilters = false;
  public states: State[] = [];
  public selectedStates: State[] = [];
  public SIGNTYPE_ONE2ONE = SignType.One2One;
  public SIGNTYPE_BATCH = SignType.Batch;
  public SIGNTYPE_DYNAMIC = SignType.Dynamic;
  public myPendingState: State = new State();
  public pendingState: State = new State();
  public REVIEWTYPE_ONE2ONE = ReviewType.One2One;
  public REVIEWTYPE_BATCH = ReviewType.Batch;
  public partnerId: number;
  public readonly MODAL_REASIGN_PARTICIPANT = 1;
  public readonly MODAL_FINALIZE_DOCUMENT = 2;
  public nameOfTheDocumentsBeingSigned: string[] = [];
  public enterpriseStorage: any = new EnterpriseStorage();
  public existLimitStorage: boolean;
  pageNumber: any;
  pageNumbers: any[] = [];
  private geolocation: GeolocationIofesign;
  private longitude = null;
  private latitude = null;
  private accuracy = null;

  constructor(private sanitizer: DomSanitizer,
              private modalService: NgbModal,
              private documentService: DocumentService,
              private signService: SignService,
              private uanatacaService: UanatacaService,
              private authenticationService: AuthService,
              private applicationService: ApplicationService,
              private notificationService: NotificationService,
              private personService: PersonService,
              private router: Router,
              private mailtemplateService: MailtemplateService,
              private translate: TranslateService,
              private storageService: EnterpriseStorageService,
              private publicService: PublicService,
              private workflowService: WorkflowService,
              private workflowDataService: WorkflowDataService,
              private enterpriseDataService: EnterpriseDataService,
              private geolocationService: GeolocationService) {
    Dialog.createInstance(modalService);
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
    this.searchFilters = LocalStorage.searchDocument() || new SearchDocument();
    this.subject = this.searchFilters.subject || '';
    this.officialSubject = this.subject;
    this.setDefaultData();
    this.showAdditionalFilters = this.invalidDateRange;
    this.loadDocuments(Page.First);
    this.beginAutorefreh();
    this.loadStorage();
  }

  ngOnDestroy(): void {
    this.destroyAutorefresh();
    clearInterval(this.storageInterval);
  }

  private setDefaultData() {
    this.personId = LocalStorage.getPersonId();
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.workflows = LocalStorage.getDefaultWorkflows();
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = [{id: Constant.ALL_PARTNER_ID, name: 'TODOS'}, ...(LocalStorage.getPartners() || [])];
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.partnerId = this.partnerSelected.id;
      this.updateEnterprises();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.partnerId = LocalStorage.getPartnerId();
      this.updateEnterprises();
    } else if (this.hasRole(this.ROLE_ADMIN) || this.hasRole(this.ROLE_LITE_ADMIN)) {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseIdView();
      this.updateWorkflows();
      this.partnerId = LocalStorage.getPartnerId();
    } else {
      this.enterpriseIdSelected = this.authenticationService.getEnterpriseId();
      this.updateWorkflows();
      this.partnerId = LocalStorage.getPartnerId();
    }
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    this.workflowIdSelected = this.workflowSelected?.id ?? 0;
    this.loadStates();
    this.stablishMyPendingState();
    this.stablishPendingState();
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN) || this.hasRole(this.ROLE_SUPERVISOR) || this.hasRole(this.ROLE_LITE_ADMIN)) {
      this.pushDefaultStateValue4Adms();
    } else if (this.hasRole(this.ROLE_ASSISTANT) || this.hasRole(this.ROLE_LITE_ASSISTANT)) {
      this.pushDefaultStateValue4Assistants();
    } else {
      this.pushDefaultStateValue4NotAdms();
    }
  }

  private stablishMyPendingState() {
    this.myPendingState = CloneTool.do(this.states.find(value => value.id === DocumentState.MY_PENDINGS));
    const index = this.states.findIndex(value => DocumentState.MY_PENDINGS === value.id);
    this.states.splice(index, 1);
  }

  private stablishPendingState() {
    this.pendingState = CloneTool.do(this.states.find(value => value.id === DocumentState.PENDING));
  }

  public reloadDocuments1() {
    this.enterpriseIdSelected = this.enterpriseSelected?.id ?? Constant.ALL_ENTERPRISE_ID;
    this.updateWorkflows();
    if (this.hasAuthority('own:view:bar:limit:storage:500')) {
      this.getStorage();
    }
    this.search(false);
  }

  public reloadDocuments2() {
    this.workflowIdSelected = this.workflowSelected?.id ?? 0;
    this.search(false);
  }

  public onPartnerChange(): void {
    this.partnerId = this.partnerSelected?.id ?? Constant.ALL_PARTNER_ID;
    this.updateEnterprises();
    if (this.hasAuthority('own:view:bar:limit:storage:500')) {
      this.getStorage();
    }
    this.search(false);
  }

  private updateEnterprises(): void {
    const allEnterprises = LocalStorage.getEnterprises();
    const visibleEnterprises = this.partnerId === Constant.ALL_PARTNER_ID
      ? allEnterprises
      : allEnterprises.filter(enterprise => enterprise.partnerId === this.partnerId);
    this.enterpriseDataService.setEnterprises(allEnterprises);
    this.enterprises = LocalStorage.addEnterprise(visibleEnterprises);
    this.enterpriseSelected = this.enterprises[Constant.ZERO_INDEX];
    this.enterpriseIdSelected = this.enterpriseSelected.id;
    this.updateWorkflows();
  }

  private updateWorkflows(): void {
    let available: Workflow[];
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER)) {
      const enterpriseIds = this.enterprises.filter(enterprise => enterprise.id !== Constant.ALL_ENTERPRISE_ID)
        .map(enterprise => enterprise.id);
      available = LocalStorage.getWorkflows().filter(workflow =>
        workflow.ready2Use === Constant.READY_TO_USE &&
        (this.enterpriseIdSelected === Constant.ALL_ENTERPRISE_ID
          ? enterpriseIds.indexOf(workflow.enterpriseId) !== -1
          : workflow.enterpriseId === this.enterpriseIdSelected));
    } else if (this.hasRole(this.ROLE_ADMIN) || this.hasRole(this.ROLE_LITE_ADMIN)) {
      available = LocalStorage.getWorkflowsBy(this.enterpriseIdSelected);
    } else {
      available = LocalStorage.getWorkflowsByPerson();
    }
    this.workflowDataService.setWorkflows(available);
    this.workflows = LocalStorage.getDefaultWorkflows().concat(available);
    this.workflowSelected = this.workflows[Constant.ZERO_INDEX];
    this.workflowIdSelected = this.workflowSelected.id;
  }

  private refreshDocuments(preserveSelection = false): void {
    this.documents = [];
    if (!preserveSelection) {
      this.selectedDocuments = [];
    }
    this.loadDocuments(Page.First);
  }

  public loadDocuments(page: Page, callAutorefresh?: string): void {
    this.calledOfAutorefresh = false;
    if (callAutorefresh) {
      this.calledOfAutorefresh = true;
    }
    if (this.officialSubject === undefined) {
      this.officialSubject = '';
    }
    const searchDocument = LocalStorage.searchDocument();
    let stateIdentifiers = this.removeInnecesaryStateIds(StringUtil.concatIdentifiers2(this.selectedStates, ','));
    // Mostrar los documentos con lo siguientes estados solo para los usuarios que tengan ese permiso.
    if (this.hasAuthority('own:view:document:10202')) {
      stateIdentifiers = '1,6,9,10,15,41,60';
    }
    switch (page) {
      case Page.First:
        if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN) || this.hasRole(this.ROLE_SUPERVISOR) || this.hasRole(this.ROLE_LITE_ADMIN)) {
          this.documentUrl = Constant.ROOT_API_V1
            .concat('/partner/')
            .concat(String(this.partnerId))
            .concat('/enterprises/')
            .concat(String(this.enterpriseIdSelected))
            .concat('/workflows/')
            .concat(String(this.workflowIdSelected))
            .concat('/documents')
            .concat('?subject=')
            .concat(encodeURIComponent(this.officialSubject))
            .concat('&states=')
            .concat(stateIdentifiers);
        } else if (this.hasRole(this.ROLE_ASSISTANT) || this.hasRole(this.ROLE_LITE_ASSISTANT)) {
          this.documentUrl = Constant.ROOT_API_V1
            .concat('/enterprises/')
            .concat(String(this.enterpriseIdSelected))
            .concat('/workflows/')
            .concat(String(this.workflowIdSelected))
            .concat('/documents')
            .concat('?subject=')
            .concat(encodeURIComponent(this.officialSubject))
            .concat('&states=')
            .concat(stateIdentifiers);
        } else {
          // TODO ROLE_USER list view
          this.documentUrl = Constant.ROOT_API_V1
            .concat('/enterprises/')
            .concat(String(this.enterpriseIdSelected))
            .concat('/workflows/')
            .concat(String(this.workflowIdSelected))
            .concat('/user/documents')
            .concat('?subject=')
            .concat(encodeURIComponent(this.officialSubject))
            .concat('&states=')
            .concat(stateIdentifiers);
        }
        if (searchDocument) {
          this.documentUrl += ''
            .concat('&documentNumber=')
            .concat(encodeURIComponent(searchDocument.documentNumber || ''))
            .concat('&fullName=')
            .concat(encodeURIComponent(searchDocument.fullName || ''))
            .concat('&ruc=')
            .concat(encodeURIComponent(searchDocument.ruc || ''))
            .concat('&businessName=')
            .concat(encodeURIComponent(searchDocument.businessName || ''))
            .concat('&dateFrom=')
            .concat(encodeURIComponent(searchDocument.dateFrom || ''))
            .concat('&dateTo=')
            .concat(encodeURIComponent(searchDocument.dateTo || ''))
            .concat('&uploader=')
            .concat(encodeURIComponent(searchDocument.uploader || ''));
        } else {
          this.documentUrl += ''
            .concat('&documentNumber=')
            .concat('&fullName=')
            .concat('&ruc=')
            .concat('&businessName=')
            .concat('&dateFrom=')
            .concat('&dateTo=')
            .concat('&uploader=');
        }
        this.documentUrl += '&size=' + this.pageNumber + '&sort=id,desc';
        break;
      case Page.Previous:
        this.documentUrl = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        this.documentUrl = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        this.documentUrl = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        this.documentUrl = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    if (this.authenticationService.isAuthenticated()) {
      this.getDocuments(this.documentUrl);
    } else {
      this.logout();
    }
  }

  private beginAutorefreh() {
    this.interval = setInterval(() => {
      if (this.documents.length !== 0) {
        this.loadDocuments(Page.Self, 'auto');
      } else {
        this.loadDocuments(Page.First, 'auto');
      }
    }, 60000);
  }

  private destroyAutorefresh() {
    clearInterval(this.interval);
  }

  private getDocuments(url: string) {
    this.loading = true;
    this.documentService.get(url).subscribe((next: any) => {
      this.loadingShowBy = this.loading = false;
      if (next._embedded) {
        const stateIdentifiers = this.removeInnecesaryStateIds(StringUtil.concatIdentifiers2(this.selectedStates, ','));
        if (stateIdentifiers === '30') {
          this.documents = next._embedded.documents.filter(document => {
            if (document.freelySignature) {
              if (this.hasReviewOption(document) && this.enabledReviewOption(document)) {
                return true;
              } else if (this.hasUniqueAttachDigitalSignatureOption(document) && this.completedReview(document)) {
                return true;
              } else if (this.hasMultipleAttachDigitalSignatureOption(document) && this.completedReview(document)) {
                return true;
              } else {
                return false;
              }
            } else {
              return true;
            }
          });
        } else {
          this.documents = next._embedded.documents;
        }
      } else {
        this.documents = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.destroyAutorefresh();
      this.loadingShowBy = this.loading = false;
      this.processError(this.translate.instant('TITLE.DOCUMENTS'), error);
    });
  }

  /**
   * Carga los datos necesarios para el módulo de agregar documentos en lote y luego abre el modal para agregar los
   * documentos
   */
  public loadRequiredDataAndOpenModalAddBatch() {
    this.getWorkflows().subscribe({
      next: () => {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/required-data?component=add-document-batch');
        this.applicationService.get(url).subscribe((next: any) => {
          this.loading = false;
          LocalStorage.setUpEmbeddedInfo(next);
          this.openModalAddBatch();
        }, () => {
          this.loading = false;
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENTS'));
        });
      }
    });
  }

  /**
   * Modal especifico para carga de documentos de notificación
   */
  public loadRequiredDataAndOpenModalAddNotifyBatch() {
    this.getWorkflows().subscribe({
      next: () => {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/required-data?component=add-document-batch');
        this.applicationService.get(url).subscribe((next: any) => {
          this.loading = false;
          LocalStorage.setUpEmbeddedInfo(next);
          this.openModalAddNotifyBatch();
        }, () => {
          this.loading = false;
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENTS'));
        });
      }
    });
  }

  openModalAddBatch() {
    const modalRef = this.modalService.open(AddDocumentBatchComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.enterpriseIdSelected = this.enterpriseIdSelected;
    this.entityName = this.translate.instant('TITLE.DOCUMENT');
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadDocuments(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  openModalAddNotifyBatch() {
    const modalRef = this.modalService.open(AddDocumentNotifyBatchComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.enterpriseIdSelected = this.enterpriseIdSelected;
    this.entityName = this.translate.instant('TITLE.DOCUMENT');
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadDocuments(Page.Self);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public getUrlsSign(document: Document): SafeUrl {
    const urlFrom = DocumentUtil.buildUrlDownload(document, LocalStorage.getPersonId());
    const urlTo = DocumentUtil.buildUrlUpload(document, this.personId);
    if (document._more.stampdatetime) {
      const stampdatetime: Stampdatetime = document._more.stampdatetime;
      return 'rsign:?from='
        .concat(urlFrom)
        .concat('&to=')
        .concat(urlTo)
        .concat('&vis_sig_x=')
        .concat(String(stampdatetime.positionX))
        .concat('&vis_sig_y=')
        .concat(String(stampdatetime.positionY))
        .concat('&vis_sig_width=')
        .concat(String(stampdatetime.widthContainer))
        .concat('&vis_sig_height=')
        .concat(String(stampdatetime.heightContainer))
        .concat('&vis_sig_text=')
        .concat(stampdatetime.description)
        .concat('&vis_sig_page=')
        .concat(String(stampdatetime.stampOn));
    }
    return 'rsign:?from='
      .concat(urlFrom)
      .concat('&to=')
      .concat(urlTo);
  }

  public addOrRemove(event, document: any) {
    if (event.target.checked) {
      this.selectedDocuments.push(document);
    } else {
      const index = this.getIndexOf(document);
      this.selectedDocuments.splice(index, 1);
    }
  }

  public wasSelected(document: any): boolean {
    return this.isAdded(document);
  }

  private isAdded(document: any): boolean {
    return this.selectedDocuments.find(value => value.id === document.id) !== undefined;
  }

  private getIndexOf(document: any): number {
    return this.selectedDocuments.findIndex(value => value.id === document.id);
  }

  private getIndexOfState(state: State): number {
    return this.selectedStates.findIndex(value => value.id === state.id);
  }

  public addOrRemoveAll(event) {
    if (event.target.checked) {
      this.documents.filter(document => !this.isAdded(document)).forEach(document => this.selectedDocuments.push(document));
    } else {
      this.documents.filter(document => this.isAdded(document)).forEach(document => this.selectedDocuments.splice(this.getIndexOf(document), 1));
    }
  }

  public wasAllSelected(): boolean {
    if (this.selectedDocuments.length === 0) {
      return false;
    }
    // tslint:disable-next-line:no-unused-expression
    this.isAllowedDeleteInBatch;
    return !(this.documents.find(document => !this.isAdded(document)) !== undefined);
  }

  /**
   * Verifica si el usuario tiene el saldo suficiente para realizar esta acción
   */
  public verifyDemoNotcer(documents: Document[], documentIds: string, itsSignInBatch: boolean) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/documents/verify/demonotcer');
    this.documentService.verifyUserBalanceOrDemoNotcer(url, documents).subscribe(() => {
      if (itsSignInBatch) {
        this.signBatchBy(documentIds, documents);
      } else {
        const document = documents[0];
        this.openRCDSignatureOne2One(document);
        this.checkStatusOne2One(document);
      }
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
        return;
      } else if (HttpStatusCode.PRECONDITION_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.NOTIFY'), error.error.message);
        return;
      }
      this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
    });
  }

  /**
   * Verifica si el usuario tiene el saldo suficiente para realizar esta acción
   */
  public verifyUserBalance(documents: Document[], documentIds: string, itsSignInBatch: boolean) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/documents/verify/userbalance');
    this.documentService.verifyUserBalanceOrDemoNotcer(url, documents).subscribe(() => {
      if (itsSignInBatch) {
        this.signBatchBy(documentIds, documents);
      } else {
        const document = documents[0];
        this.openRCDSignatureOne2One(document);
        this.checkStatusOne2One(document);
      }
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UPGRADE_REQUIRED === error.status) {
        Dialog.show(InformType.Warning, this.translate.instant('TABLE.HEADER.BALANCE-IOF'), error.error.message);
        return;
      }
      this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
    });
  }

  /**
   * Verifica si los documentos a firmar tiene alguna notificacion.
   */
  public hasNotifyInDocuments(documents: Document[]): boolean {
    return documents.filter(document => document._more.sent2Visualization === true).length > 0;
  }

  public async signDigitallyBatch(hasDragRubric: boolean): Promise<void> {
    const documentsReviewed = this.selectedDocuments.filter(document => this.completedReview(document));
    if (Constant.EMPTY_LIST === documentsReviewed.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    let documents2Sign: any[] = this.selectedDocuments.filter(document => this.hasUniqueAttachDigitalSignatureOption1(document) || this.hasMultipleAttachDigitalSignatureOption(document))
      .filter(document => hasDragRubric ? document._more.dragRubric : !document._more.dragRubric)
      .filter(document => document._more.acceptRubricPlacement ? document._more.acceptRubricPlacement : false);

    if (Constant.EMPTY_LIST === documents2Sign.length) {
      documents2Sign = this.selectedDocuments.filter(document => this.hasUniqueAttachDigitalSignatureOption1(document) || this.hasMultipleAttachDigitalSignatureOption(document))
        .filter(document => hasDragRubric ? document._more.dragRubric : !document._more.dragRubric);
    }
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }

    const documentsWithFreelySignature = documents2Sign.filter(documents2sign => documents2sign.freelySignature === true);
    if (Constant.EMPTY_LIST !== documentsWithFreelySignature.length) {
      this.validateAssignedEnable(documentsWithFreelySignature);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      if (hasDragRubric) {
        // Mostrará el POPUP de firma de documentos interno, ya que es una firma digital en lote con arrastre.
        this.openModalSignDigitalDocumentInternal(documents2Sign);
      } else {
        const documentIds = StringUtil.concatIdentifiers(documents2Sign);
        if (this.hasDemoNotcer && this.hasNotifyInDocuments(documents2Sign)) {
          this.verifyDemoNotcer(documents2Sign, documentIds, true);
        } else if (this.hasConfigBalance) {
          this.verifyUserBalance(documents2Sign, documentIds, true);
        } else {
          this.signBatchBy(documentIds, documents2Sign);
        }
      }
      this.selectedDocuments = [];
    }
  }

  public async signElectronicallyBatch(): Promise<Document[]> {
    const documentsReviewed = this.selectedDocuments.filter(document => this.completedReview(document));
    if (Constant.EMPTY_LIST === documentsReviewed.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    let documents2Sign: any[] = this.selectedDocuments.filter(document => this.hasElectronicSignatureOption1(document))
      .filter(document => document._more.acceptRubricPlacement ? document._more.acceptRubricPlacement : false);
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      documents2Sign = this.selectedDocuments.filter(document => this.hasElectronicSignatureOption1(document));
    }
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    const documentsWithFreelySignature = documents2Sign.filter(documents2sign => documents2sign.freelySignature === true);
    if (Constant.EMPTY_LIST !== documentsWithFreelySignature.length) {
      this.validateAssignedEnable(documentsWithFreelySignature);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.openModalSignDocumentInternal2(documents2Sign);
      this.selectedDocuments = [];
    }
  }

  public async notifyInBatch(): Promise<Document[]> {
    const documents2Sign: any[] = this.selectedDocuments.filter(document => this.hasNotificationOption(document));
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    const documentsWithFreelySignature = documents2Sign.filter(documents2sign => documents2sign.freelySignature === true);
    if (Constant.EMPTY_LIST !== documentsWithFreelySignature.length) {
      this.validateAssignedEnable(documentsWithFreelySignature);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.openModalSignDocumentInternal5(documents2Sign);
      this.selectedDocuments = [];
    }
  }

  public async signInCloudBatch(): Promise<void> {
    const documentsReviewed = this.selectedDocuments.filter(document => this.completedReview(document));
    if (Constant.EMPTY_LIST === documentsReviewed.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    let documents2Sign: any[] = this.selectedDocuments.filter(document => this.hasCloudSignatureOption1(document))
      .filter(document => document._more.acceptRubricPlacement ? document._more.acceptRubricPlacement : false);
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      documents2Sign = this.selectedDocuments.filter(document => this.hasCloudSignatureOption1(document));
    }
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.SIGNATURE'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    const documentsWithFreelySignature = documents2Sign.filter(documents2sign => documents2sign.freelySignature === true);
    if (Constant.EMPTY_LIST !== documentsWithFreelySignature.length) {
      this.validateAssignedEnable(documentsWithFreelySignature);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.loadingSign = true;
      const url = Constant.ROOT_API_V1.concat('/uanataca/people/', String(LocalStorage.getPersonId()), '/documents/request/create');
      this.uanatacaService.post(url, documents2Sign).subscribe(value => {
        this.loadingSign = false;
        // this.openModalSignDocumentInternal3(documents2Sign, value);
        this.verifyAcceptTermToSignCloud(documents2Sign, value);
        this.selectedDocuments = [];
      }, error => {
        this.loadingSign = false;
        this.selectedDocuments = [];
        this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
      });
    }
  }

  public async signRemoteBatch(): Promise<void> {
    const documentsReviewed = this.selectedDocuments.filter(document => this.completedReview(document));
    if (Constant.EMPTY_LIST === documentsReviewed.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    let documents2Sign: any[] = this.selectedDocuments.filter(document => this.hasRemoteSignatureOption1(document))
      .filter(document => document._more.acceptRubricPlacement ? document._more.acceptRubricPlacement : false);
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      documents2Sign = this.selectedDocuments.filter(document => this.hasRemoteSignatureOption1(document));
    }
    if (Constant.EMPTY_LIST === documents2Sign.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-SIGNATURE'));
      this.selectedDocuments = [];
      return;
    }
    const documentsWithFreelySignature = documents2Sign.filter(documents2sign => documents2sign.freelySignature === true);
    if (Constant.EMPTY_LIST !== documentsWithFreelySignature.length) {
      this.validateAssignedEnable(documentsWithFreelySignature);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.loadingSign = true;
      this.openModalSignDocumentInternal4(documents2Sign);
      this.loadingSign = false;
      this.selectedDocuments = [];
    }
  }

  public async reviewBatch() {
    const documents2Review: Document[] = this.selectedDocuments.filter(document => this.hasReviewOption(document));
    if (Constant.EMPTY_LIST === documents2Review.length) {
      Dialog.show(InformType.Info, this.translate.instant('TITLE.DOCUMENTS'), this.translate.instant('MESSAGE.NOT-PENDING-REVIEW'));
      this.selectedDocuments = [];
      return;
    }
    const documentsWithFreelySignature = documents2Review.filter(documents2review => documents2review.freelySignature === true);
    if (Constant.EMPTY_LIST !== documentsWithFreelySignature.length) {
      this.validateAssignedEnable(documentsWithFreelySignature);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.openModalReview2(documents2Review, ReviewType.Batch, 'xl');
    }
  }

  // TODO correct pass parameters, services shouldn't build urls
  public checkStatusOne2One(document: Document) {
    const urlOne2One = Constant.ROOT_API_V1.concat('/public/signs/one2one/status')
      .concat('?personId=')
      .concat(String(this.personId))
      .concat('&documentId=')
      .concat(String(document.id));
    this.loadingSign = true;
    const interval = setInterval(() => {
      this.documentService.get(urlOne2One).subscribe((next: any) => {
        if (next.completed === Constant.FINISHED) {
          const documents: Document[] = [];
          documents.push(document);
          Dialog.show(InformType.Success, this.translate.instant('TITLE.DOCUMENT'));
          this.saveGeolocation(documents, this.personId, 'Firma digital');
          clearInterval(interval);
          this.loadDocuments(Page.Self);
          this.selectedDocuments = [];
          this.loading = false;
          this.loadingSign = false;
          this.loadActualBalance();
          if (this.hasAuthority('own:view:document:10202')) {
            this.downloadAndSentDocument(document);
          }
        }
      }, error => {
        this.processError(this.translate.instant('TITLE.DOCUMENTS'), error);
      });
    }, 2000);
  }

  openRCDSignatureOne2One(document: Document): void {
    const rsignUrl = this.getUrlsSign(document).toString();
    window.open(rsignUrl, '_self');
  }

  public downloadAndSentDocument(document: Document) {
    const interval1 = setInterval(() => {
      const document1 = this.documents.find(value => value.id === document.id);
      if (document1.finished) {
        clearInterval(interval1);
        this.openModalSendDocumentViaEmail(document1);
        this.downloadOf(document1);
      }
    }, 2000);
  }

  public async openComponentToSignDocumentOneToOneAndUniqueAttachment(document: Document) {
    const documents: Document[] = [];
    documents.push(document);
    if (document.freelySignature) {
      this.validateAssignedEnable(documents);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      if (this.hasDemoNotcer && this.hasNotifyInDocuments(documents)) {
        this.verifyDemoNotcer(documents, '0', false);
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance(documents, '0', false);
      } else {
        this.openRCDSignatureOne2One(document);
        this.checkStatusOne2One(document);
      }
    }
  }

  public async openModalSignDigital(document: Document) {
    if (document._more.dragRubric && document._more.hasRubricSettings) {
      const documents: Document[] = [];
      documents.push(document);
      if (document.freelySignature) {
        this.validateAssignedEnable(documents);
        await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
      }
      if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
        this.openModalSignDigitalDocumentInternal(documents);
      }
    } else {
      this.getCurrentLocation();
      if (this.hasMultipleAttachDigitalSignatureOption(document)) {
        this.openComponentToSignDocumentOneToOneAndMultiAttachment(document);
      } else {
        this.openComponentToSignDocumentOneToOneAndUniqueAttachment(document);
      }
    }
  }

  private loadActualBalance(): void {
    if (!this.hasConfigBalance) {
      return;
    }
    this.loading = true;
    const url = Constant.ROOT_API_V1 + '/actualbalance';
    this.applicationService.get(url).subscribe((value: any) => {
      LocalStorage.setUpEmbeddedInfo(value);
      this.loading = false;
    }, error => {
      this.loading = false;
      this.processError(this.translate.instant('TITLE.CURRENT-BALANCE'), error);
    });
  }

  public downloadOf(documentsource: any) {
    const url = documentsource._links.stream.href.replace('http', Constant.SCHEMA);
    const more = documentsource._more;
    this.documentService.download(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = more.basenameFile.concat(more.suffix === undefined ? '' : more.suffix, '.', more.extension);
      control.click();
    }, error => {
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      this.processError(title, error);
    });
  }

  /**
   * Realiza la descarga del acuse de recibo del documento notificado.
   */
  public downloadAcknowledgmentReceipt(document1: Document) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/document/', String(document1.id), '/acknowledgmentreceipt/stream');
    this.uanatacaService.get(url).subscribe(next => {
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      control.download = document1.subject + ' - Acuse de entrega';
      control.click();
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  public hasUniqueAttachSignOption(document: Document) {
    return !document.finished &&
      (this.personId === document._more.personId) &&
      (Constant.SIGN_OPTION === document._more.operationId) &&
      (document.active === Constant.ACTIVE) &&
      (document.hasMultipleAttachments !== Constant.HAS_MULTIPLE_ATTACHMENTS) &&
      !this.wasCanceled(document);
  }

  public hasUniqueAttachNotifyOption(document: Document) {
    return !document.finished &&
      (this.personId === document._more.personId) &&
      (document.active === Constant.ACTIVE) &&
      (document.hasMultipleAttachments !== Constant.HAS_MULTIPLE_ATTACHMENTS) &&
      !this.wasCanceled(document);
  }

  /**
   * Evaluamos si tiene el permiso de firma digital sobre un documento que tiene un único adjunto.
   */
  public hasUniqueAttachDigitalSignatureOption(document: Document) {
    return this.hasUniqueAttachSignOption(document) && TypeSignature.DIGITAL === document._more.typeSignature
      && !document._more.sent2Visualization;
  }

  /**
   * Evaluamos si tiene el permiso de firma digital sobre un documento que tiene un único adjunto.
   */
  public hasUniqueAttachDigitalSignatureOption1(document: Document) {
    return this.hasUniqueAttachSignOption(document) && TypeSignature.DIGITAL === document._more.typeSignature;
  }

  /**
   * Evaluamos el permiso de firma gráfica que tenga uno o más adjuntos
   */
  public hasElectronicSignatureOption(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document)) &&
      TypeSignature.ELECTRONIC === document._more.typeSignature && !document._more.sent2Visualization;
  }

  /**
   * Evaluamos el permiso de firma gráfica que tenga uno o más adjuntos
   */
  public hasElectronicSignatureOption1(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document)) &&
      TypeSignature.ELECTRONIC === document._more.typeSignature;
  }

  /**
   * Evaluamos el permiso de Notificación.
   */
  public hasNotificationOption(document: Document) {
    return (this.hasUniqueAttachNotifyOption(document) || this.hasMultipleAttachNotifyOption(document)) &&
      TypeSignature.ANYTHING === document._more.typeSignature && WorkflowType.NOTCER === document._more.workflowType
      && document._more.sent2Visualization && !document._more.notifyAfterUpload && !document._more.scheduledNotify;
  }

  /**
   * Evaluamos el permiso de Notificación y firma.
   */
  public hasNotificationAndSignOption(document: Document) {
    return (this.hasUniqueAttachNotifyOption(document) || this.hasMultipleAttachNotifyOption(document)) &&
      TypeSignature.ANYTHING !== document._more.typeSignature && WorkflowType.NOTCER === document._more.workflowType
      && document._more.sent2Visualization;
  }

  public hasCloudSignatureOption(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document)) &&
      TypeSignature.CLOUD === document._more.typeSignature && document._more.validPerson &&
      !document._more.sent2Visualization;
  }

  public hasCloudSignatureOption1(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document)) &&
      TypeSignature.CLOUD === document._more.typeSignature && document._more.validPerson;
  }

  /**
   * Evalua si la firma si la firma que debe hacer es remota (signbox)
   */
  public hasRemoteSignatureOption(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document))
      && TypeSignature.REMOTE === document._more.typeSignature && !document._more.sent2Visualization;
  }

  /**
   * Evalua si la firma si la firma que debe hacer es remota (signbox)
   */
  public hasRemoteSignatureOption1(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document))
      && TypeSignature.REMOTE === document._more.typeSignature;
  }

  public hasntDataComplete(document: Document) {
    return (this.hasUniqueAttachSignOption(document) || this.hasMultipleAttachSignOption(document)) &&
      TypeSignature.CLOUD === document._more.typeSignature
      && (!document._more.completeData || !document._more.hasPersonConfirmation || this.isInvalidPerson(document));
  }

  /**
   * Evalua si la persona ha sido evaluada y rechazada por los operadores del solcert.
   */
  public isInvalidPerson(document: Document) {
    if (document._more.hasPersonConfirmation) {
      return !document._more.validPerson && document._more.stateSolcert && document._more.stateSolcert !== StateSolcert.CREATE && document._more.stateSolcert !== StateSolcert.ATTEND;
    } else {
      return false;
    }
  }

  /**
   * Evalua si la persona ha sido evaluada y rechazada por los operadores del solcert.
   */
  public isInvalidPersonByValidityPeriod(document: Document) {
    if (document._more.hasPersonConfirmation) {
      return !document._more.validPerson && document._more.stateSolcert === StateSolcert.ATTEND;
    } else {
      return false;
    }
  }

  /**
   * Evalua si la persona ha sido evaluada y rechazada por los operadores del solcert.
   */
  public hasntPersonConfirmation(document: Document) {
    return !document._more.hasPersonConfirmation && TypeSignature.CLOUD === document._more.typeSignature;
  }

  /**
   * Obtiene la descripción del estado de la solicitud de validación de documentos.(CORREGIR O COMPLETAR DATOS)
   */
  public getDescription4Action(document: Document) {
    if (document._more.hasPersonConfirmation) {
      return this.isInvalidPerson(document) && document._more.stateSolcert ? 'MESSAGE.MODIFY-DATA' : 'MESSAGE.FILL-IN-DATA';
    } else {
      return 'MESSAGE.FILL-IN-DATA';
    }
  }

  public hasReviewOption(document: any) {
    return !document.finished &&
      (this.personId === document._more.personId) &&
      (Constant.REVIEW_OPTION === document._more.operationId) &&
      (document.active === Constant.ACTIVE) &&
      !this.wasCanceled(document);
  }

  public hasResendMailOption(document: any): boolean {
    if (!document.freelySignature) {
      return !document.finished && (document._more.participantType === Constant.INVITED) &&
        (document._more.hasAlertWsp === TypeAlert.WHATSTAPP || document._more.hasAlertEmail === TypeAlert.EMAIL) &&
        (document.active === Constant.ACTIVE) && !this.isInvitedUser;
    }
    return !document.finished && document._more.haveInvited && (document._more.hasAlertWsp === TypeAlert.WHATSTAPP || document._more.hasAlertEmail === TypeAlert.EMAIL) && (document.active === Constant.ACTIVE);
  }

  public hasCopyUrlOption(document: any): boolean {
    if (!document.freelySignature) {
      return !document.finished && (document._more.participantType === Constant.INVITED) &&
        (document.active === Constant.ACTIVE) && !this.isInvitedUser;
    } else {
      return !document.finished && document._more.haveInvited && (document.active === Constant.ACTIVE) && !this.isInvitedUser;
    }
  }

  public hasCancelOption(document: any) {
    return (this.hasUniqueAttachSignOption(document) || this.hasReviewOption(document) || this.hasMultipleAttachSignOption(document)) && !document.freelySignature;
  }

  public isAllowedDelete(document: any): boolean {
    return !this.wasCanceled(document) && !this.wasFinished(document) && !this.wasDelivered(document) && !this.wasAttended(document) && Constant.FIRST_OPERATION === document._more.orderNextSigner;
  }

  public wasCanceled(document: any): boolean {
    return Constant.INACTIVE === document.active || DocumentState.CANCELED === document.stateId;
  }

  /**
   * Verifica si el documento notificado ya cuenta con acuse de recibo
   */
  public hasAcknowledgmentReceipt(document: Document): boolean {
    return document._more.hasAcknowledgmentReceipt;
  }

  // TODO refactorizar el parámetro modalsize de no ser necesario en adelante
  public async openModalReview(document: Document, reviewType: ReviewType) {
    if (ReviewType.One2One === reviewType) {
      const documents: Document[] = [];
      documents.push(document);
      if (document.freelySignature) {
        this.validateAssignedEnable(documents);
        await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
      }
      if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
        this.openModalReview2(documents, ReviewType.One2One, 'xl');
      }
    }
  }

  public openModalReview2(documents: Document[], reviewType: ReviewType, modalSize: string) {
    const modalRef = this.modalService.open(ReviewDocumentComponent, {
      backdrop: 'static',
      size: modalSize
    });
    modalRef.componentInstance.reviewType = reviewType;
    modalRef.componentInstance.documents = documents;
    modalRef.componentInstance.personId = this.personId;
    this.entityName = this.translate.instant('TITLE.DOCUMENT');
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.selectedDocuments = [];
        this.loadDocuments(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Anything === result) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    });
  }

  /**
   * Carga los datos necesarios para el 'agregar documento uno a uno' y luego abre el modal para agregar el documento
   */
  public loadRequiredDataAndOpenModalAddOne() {
    this.getWorkflows().subscribe({
      next: () => {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/required-data?component=add-document');
        this.applicationService.get(url).subscribe((next: any) => {
          this.loading = false;
          LocalStorage.setUpEmbeddedInfo(next);
          this.openModalAddOne();
        }, () => {
          this.loading = false;
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENTS'));
        });
      }
    });
  }

  public openModalAddOne() {
    const modalRef = this.modalService.open(AddDocumentOneComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.enterpriseIdSelected = this.enterpriseIdSelected;
    this.entityName = this.translate.instant('TITLE.DOCUMENT');
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadDocuments(this.documents.length === 0 ? Page.First : Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  /**
   * Carga los datos necesarios para el módulo de 'agregar documentos para firma dinámica' en lote y luego abre el modal
   * para agregar el documentos
   */
  public loadRequiredDataAndOpenModalAddDynamic() {
    this.getWorkflows().subscribe({
      next: () => {
        this.loading = true;
        const url = Constant.ROOT_API_V1.concat('/required-data?component=add-document-dynamic');
        this.applicationService.get(url).subscribe((next: any) => {
          this.loading = false;
          LocalStorage.setUpEmbeddedInfo(next);
          this.openModalAddOneDynamically();
        }, () => {
          this.loading = false;
          Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENTS'));
        });
      }
    });
  }

  public openModalAddOneDynamically() {
    const modalRef = this.modalService.open(AddDocumentOneDynamicComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.enterpriseIdSelected = this.enterpriseIdSelected;
    this.entityName = this.translate.instant('TITLE.DOCUMENT');
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadDocuments(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  get isEmptySelectedList(): boolean {
    return this.selectedDocuments.length === 0;
  }

  get isEmptySelectedListAttendedDocument(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument.stateId === DocumentState.ATTENDED).length !== 0;
  }

  get isEmptySelectedListFinishedDocument(): boolean {
    return !this.isEmptySelectedList && this.listDocumentRefresh().filter(selectedDocument =>
      selectedDocument.finished === Constant.FINISHED && selectedDocument.stateId !== DocumentState.PERMANENTLY_DELETED).length !== 0;
  }

  listDocumentRefresh(): any[] {
    const listDocument: any[] = [];
    this.selectedDocuments.forEach(selectdocument => {
      if (this.documents.filter(value => value.id === selectdocument.id).length !== 0) {
        const document = this.documents.filter(value => value.id === selectdocument.id)[0];
        listDocument.push(document);
      }
    });
    return listDocument;
  }

  get isEmptySelectedListReview(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.operationId === Constant.REVIEW_OPTION).length !== 0;
  }

  get isEmptySelectedListCloudSignatures(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.typeSignature === TypeSignature.CLOUD).length !== 0;
  }

  get isEmptySelectedListRemoteSignatures(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.typeSignature === TypeSignature.REMOTE).length !== 0;
  }

  get isEmptySelectedListElectronicSignatures(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.typeSignature === TypeSignature.ELECTRONIC).length !== 0;
  }

  get isEmptySelectedListNotify(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.typeSignature === TypeSignature.ANYTHING
      && selectedDocument._more.workflowType === WorkflowType.NOTCER && selectedDocument._more.sent2Visualization).length !== 0;
  }

  get isEmptySelectedListDigitalSignatures(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.typeSignature === TypeSignature.DIGITAL && !selectedDocument._more.dragRubric).length !== 0;
  }

  get isEmptySelectedListDigitalSignaturesWithDragRubric(): boolean {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument._more.typeSignature === TypeSignature.DIGITAL && selectedDocument._more.dragRubric).length !== 0;
  }

  public hasComment(document: any): boolean {
    if (document._more) {
      return Constant.HAS_COMMENT === document._more.hasComment || this.wasCanceled(document) || this.wasModified(document);
    }
  }

  public openModalCancel(document: any) {
    const modalRef = this.modalService.open(CancelDocumentComponent);
    modalRef.componentInstance.document = document;
    this.entityName = this.translate.instant('TITLE.DOCUMENT');
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.entityName);
        this.loadDocuments(Page.Self);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public viewObservation(document: any) {
    const documentId = document.id;
    let url;
    if (this.wasModified(document)) {
      url = Constant.ROOT_API_V1.concat('/documents/', documentId, '/obsmodification');
    } else {
      url = Constant.ROOT_API_V1.concat('/documents/', documentId, '/obscancel');
    }
    this.loadingSave = true;
    this.documentService.get(url).subscribe((observation: Observationcancel) => {
      this.loadingSave = false;
      this.openModalViewObservation(document, observation);
    }, () => {
      this.loadingSave = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.DOCUMENT'));
    });
  }

  public getStatus(document: any): string {
    if (this.hasCloudSignatureOption(document)) {
      return 'Listo para firmar';
    } else if (this.hasntDataComplete(document)) {
      return 'Falta completar datos';
    } else if (this.isInvalidPersonByValidityPeriod(document)) {
      return 'Validar documentos';
    } else {
      return 'en proceso de validación';
    }
  }

  public getTypeSignPerson(document: any): string {
    return document._more.typePersonId === Constant.LEGAL_PERSON ? 'Persona Juridica' : 'Persona Natural';
  }


  public isOneSignSignature(document: any): boolean {
    return TypeSignature.CLOUD === document._more.typeSignature;
  }

  public openModalViewObservation(document?: any, observationcancel?: Observationcancel) {
    const modalRef = this.modalService.open(ViewObservationCancelComponent, {size: 'lg'});
    modalRef.componentInstance.observationcancel = observationcancel;
    modalRef.componentInstance.document = document;
  }

  public resendMailSigner(document: any) {
    const hashIdentifier = document.hashIdentifier;
    if (!document.freelySignature) {
      const personId = document._more.personId;
      const url = Constant.ROOT_API_V1.concat('/notifications/', personId, '/people/', hashIdentifier, '/documents/resend');
      this.loading = true;
      this.notificationService.resend(url).subscribe(() => {
        this.loading = false;
        Dialog.show(InformType.Success, this.getDescription(document));
      }, error => {
        this.loading = false;
        const title = this.getDescription(document);
        this.processError(title, error);
      });
    } else {
      let people: Person[];
      const fromUrl = Constant.ROOT_API_V1
        .concat('/documents/')
        .concat(document.id)
        .concat('/invited-people');
      this.personService.get(fromUrl).subscribe((value: any) => {
        people = value._embedded.people;
        const modalRef = this.modalService.open(ShowForwardUrlComponent, {
          backdrop: 'static'
        });
        modalRef.componentInstance.people = people;
        modalRef.componentInstance.hashIdentifier = hashIdentifier;
        modalRef.result.then(informType => {
          if (informType === InformType.Success) {
            Dialog.show(InformType.Success, this.getDescription(document));
          }
        });
      }, error => {
        const title = this.translate.instant('TITLE.PARTICIPANTS');
        this.processError(title, error);
      });
    }

  }

  public getDescription(document: any): string {
    if (document._more.hasAlertWsp === TypeAlert.WHATSTAPP && document._more.hasAlertEmail === TypeAlert.EMAIL) {
      return this.translate.instant('TITLE.ALERT-GENERAL');
    } else if (document._more.hasAlertWsp === TypeAlert.WHATSTAPP) {
      return this.translate.instant('TITLE.ALERT-WSP');
    } else {
      return this.translate.instant('TITLE.ALERT-EMAIL');
    }
  }

  public copyToClipboard(documentSelected: any) {
    if (documentSelected.freelySignature) {
      const fromUrl = Constant.ROOT_API_V1
        .concat('/documents/')
        .concat(documentSelected.id)
        .concat('/invited-people');
      this.personService.get(fromUrl).subscribe((next: any) => {
        const modalRef = this.modalService.open(ShowCopyUrlComponent, {
          backdrop: 'static'
        });
        modalRef.componentInstance.people = next._embedded.people;
        modalRef.componentInstance.documentSelected = documentSelected;
      }, error => {
        const title = this.translate.instant('TITLE.PARTICIPANTS');
        this.processError(title, error);
      });
    } else {
      const selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = documentSelected._more.urlSignOperator;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
      this.loadingCopyClipboard = true;
      setTimeout(() => {
        this.loadingCopyClipboard = false;
      }, 300);
    }
  }

  public hasRole(roleDescription: string) {
    return this.authenticationService.hasRole(roleDescription);
  }

  /**
   * Verifica si tiene demos NOTCER
   */
  get hasDemoNotcer(): boolean {
    return LocalStorage.hasDemoNotcer();
  }

  public openModalAttend(document?: any) {
    let listDocuments: any[] = [];
    if (document) {
      listDocuments.push(document);
    } else {
      listDocuments = this.selectedDocuments;
    }
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.ATTEND-DOCUMENT');
    modalRef.componentInstance.body = this.buildBodyContent(listDocuments);
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.attendUnattend(listDocuments, DocumentState.ATTENDED);
      }
    });
  }

  private buildBodyContent(listDocuments: any[]): string {
    const lengthList = listDocuments.length;
    if (lengthList > 1) {
      return String(this.translate.instant('QUESTION.ARE-YOU-SURE-ATTEND-DOCUMENTS').concat(lengthList));
    }
    return this.translate.instant('QUESTION.ARE-YOU-SURE-ATTEND-DOCUMENT');
  }

  private attendUnattend(listDocuments: any[], documentState: number) {
    const attendUnattendUrl = Constant.ROOT_API_V1
      .concat('/people/')
      .concat(String(this.personId))
      .concat('/states/')
      .concat(String(documentState))
      .concat('/documents/update');
    this.loadingAttend = true;
    this.documentService.update(attendUnattendUrl, listDocuments).subscribe(() => {
      this.loadingAttend = false;
      this.selectedDocuments = [];
      this.checkedShowAllOption = false;
      this.loadDocuments(Page.Self);
      Dialog.show(InformType.Success, this.translate.instant('TITLE.DOCUMENT'));
    }, error => {
      this.loadingAttend = false;
      this.processError(this.translate.instant('TITLE.DOCUMENTS'), error);
    });
  }

  public hasMarkAttendOption(document: any) {
    return !this.wasAttended(document) && Constant.FINISHED === document.finished && !this.isInvitedUser && !this.wasDeleted(document);
  }

  public hasMarkUnattendOption(document: any) {
    return this.wasAttended(document) && !this.isInvitedUser;
  }

  public wasAttended(document: any): boolean {
    return DocumentState.ATTENDED === document.stateId;
  }

  public wasDelivered(document: any): boolean {
    return DocumentState.DELIVERED === document.stateId;
  }

  public wasFinished(document: Document): boolean {
    return DocumentState.FINISHED === document.stateId;
  }

  public wasFinishedAndDeleted(document: Document): boolean {
    return DocumentState.PERMANENTLY_DELETED === document.stateId;
  }

  public wasMailSent(document: any): boolean {
    return DocumentState.ATTACH_SENT === document.stateId;
  }

  public hasSentAttachByMailOption(document: any) {
    return Constant.FINISHED === document.finished && !this.isInvitedUser && !this.wasCanceled(document) && !this.wasDeleted(document);
  }

  public getSpanClass(document: any): string {
    if (this.wasObserved(document)) {
      return 'badge badge badge-warning';
    } else if (this.wasAttended(document)) {
      return 'badge badge-success';
    } else if (this.wasDelivered(document)) {
      return 'badge badge-warning';
    } else if (this.wasFinished(document)) {
      return 'badge badge-info';
    } else if (this.wasFinishedAndDeleted(document)) {
      return 'badge badge-success';
    } else if (this.wasCanceled(document)) {
      return 'badge badge-danger';
    } else if (this.wasMailSent(document)) {
      return 'badge custom-badge-attach-sent';
    } else if (this.wasModified(document)) {
      return 'badge custom-badge-modified';
    } else if (this.isPendingModification(document)) {
      return 'badge custom-badge-modified';
    } else {
      return '';
    }
  }

  public hasMultipleAttachDigitalSignatureOption(document: Document) {
    return this.hasMultipleAttachSignOption(document) && TypeSignature.DIGITAL === document._more.typeSignature;
  }

  public hasMultipleAttachSignOption(document: Document) {
    return !document.finished &&
      (this.personId === document._more.personId) &&
      (Constant.SIGN_OPTION === document._more.operationId) &&
      (document.active === Constant.ACTIVE) &&
      (document.hasMultipleAttachments === Constant.HAS_MULTIPLE_ATTACHMENTS) &&
      !this.wasCanceled(document);
  }

  public hasMultipleAttachNotifyOption(document: Document) {
    return !document.finished &&
      (this.personId === document._more.personId) &&
      (document.active === Constant.ACTIVE) &&
      (document.hasMultipleAttachments === Constant.HAS_MULTIPLE_ATTACHMENTS) &&
      !this.wasCanceled(document);
  }

  public async openComponentToSignDocumentOneToOneAndMultiAttachment(document: Document) {
    const documents: Document[] = [];
    documents.push(document);
    if (document.freelySignature) {
      this.validateAssignedEnable(documents);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      const documentIds = StringUtil.concatIdentifiers(documents);
      if (this.hasDemoNotcer && this.hasNotifyInDocuments(documents)) {
        this.verifyDemoNotcer(documents, documentIds, true);
      } else if (this.hasConfigBalance) {
        this.verifyUserBalance(documents, documentIds, true);
      } else {
        this.signBatchBy(documentIds, documents);
      }
    }
  }

  public signBatchBy(documentIds: string, documents?: Document[]) {
    this.signService.getUUID(this.personId, documentIds).subscribe((next: any) => {
      const fromUrl = Constant.ROOT_API_V1
        .concat('/public/signs/batch/stream?uuid=')
        .concat(next.uuid);
      const rsignUrl = 'rsign:?batch_csv='.concat(fromUrl);
      window.open(rsignUrl, '_self');

      const checkStatusBatchUrl = Constant.ROOT_API_V1
        .concat('/public/signs/batch/status')
        .concat('?uuid=')
        .concat(next.uuid)
        .concat('&personId=')
        .concat(String(this.personId));
      this.loadingSign = true;
      this.title = this.translate.instant('TITLE.DOCUMENTS');
      const interval = setInterval(() => {
        this.documentService.get(checkStatusBatchUrl).subscribe((next2: any) => {
          if (next2.completed === Constant.FINISHED) {
            Dialog.show(InformType.Success, this.translate.instant('TITLE.DOCUMENT'));
            clearInterval(interval);
            this.loadDocuments(Page.Self);
            this.selectedDocuments = [];
            this.checkedShowAllOption = false;
            this.loadingSign = false;
            this.saveGeolocation(documents, this.personId, 'Firma digital');
            this.loadActualBalance();
          }
        }, error => {
          this.processError(this.title, error);
        });
      }, 3000);
    }, error => {
      this.processError(this.title, error);
    });
  }

  get isInvitedUser(): boolean {
    return Constant.INVITED_USER === LocalStorage.getParticipantType();
  }

  public hasWorkflowsBy(signType: SignType): boolean {
    if (this.hasRole(this.ROLE_PARTNER)) {
      return true;
    }
    const workflows = DocumentUtil.extractOnlyNecesaryWorkflowsBy(this.workflowsByPerson, signType);
    return workflows.length > 0;
  }

  public hasWorkflows4Notif(): boolean {
    if (this.hasRole(this.ROLE_PARTNER)) {
      return true;
    }
    const workflows = this.workflows.filter(value => value.type === WorkflowType.NOTCER && value.send2Visualization);
    return workflows.length > 0;
  }

  get workflowsByPerson(): Workflow[] {
    if (this.hasRole(this.ROLE_ADMIN) || this.hasRole(this.ROLE_LITE_ADMIN)) {
      return this.workflows;
    } else {
      return LocalStorage.getWorkflowsByPerson();
    }
  }

  public openModalViewParticipants(document: any) {
    let list: Person[];
    const fromUrl = Constant.ROOT_API_V1
      .concat('/documents/')
      .concat(document.id)
      .concat('/people');
    this.personService.get(fromUrl).subscribe((value: any) => {
      list = value._embedded.people;
      const modalRef = this.modalService.open(ViewParticipantComponent, {
        backdrop: 'static',
        size: 'lg'
      });
      modalRef.componentInstance.peopleReceived = list;
    }, error => {
      const title = this.translate.instant('TITLE.PARTICIPANTS');
      this.processError(title, error);
    });
  }

  public openModalBy(document: any, modal: number) {
    let people: Person[];
    let modalRef;
    const fromUrl = Constant.ROOT_API_V1
      .concat('/documents/')
      .concat(document.id)
      .concat('/people');
    this.personService.get(fromUrl).subscribe((value: any) => {
      people = value._embedded.people;
      if (this.MODAL_REASIGN_PARTICIPANT === modal) {
        modalRef = this.modalService.open(ReasignParticipantComponent, {
          backdrop: 'static',
          size: 'lg'
        });
      } else if (this.MODAL_FINALIZE_DOCUMENT === modal) {
        modalRef = this.modalService.open(FinalizeDocumentComponent, {
          backdrop: 'static',
          size: 'lg'
        });
      }
      modalRef.componentInstance.people = people;
      modalRef.componentInstance.document = document;
      modalRef.result.then((result) => {
        if (InformType.Success === result) {
          Dialog.show(InformType.Success, this.translate.instant('TITLE.DOCUMENT'));
          this.loadDocuments(Page.Self);
        }
      });
    }, error => {
      this.processError(this.translate.instant('TITLE.DOCUMENTS'), error);
    });
  }

  public search(preserveSelection = true) {
    if (this.invalidDateRange) {
      return;
    }
    this.officialSubject = (this.subject || '').trim();
    this.searchFilters.subject = this.officialSubject;
    this.searchFilters.dateFrom = NgbDateStructUtil.toString(this.searchFilters.dateFrom_);
    this.searchFilters.dateTo = NgbDateStructUtil.toString(this.searchFilters.dateTo_);
    LocalStorage.setItem('_searchDocument', this.searchFilters);
    this.refreshDocuments(preserveSelection);
  }

  public hasViewParticipantsOption() {
    return !this.isInvitedUser;
  }

  public hasFinalizeDocument(document: any) {
    return this.hasReassignParticipantsOption(document) && Constant.DYNAMICALLY === document._more.dynamicWorkflow;
  }

  public hasReassignParticipantsOption(document: any) {
    return !document.freelySignature && !this.wasCanceled(document) && !this.wasFinished(document) && !this.wasDelivered(document) && !this.wasAttended(document);
  }

  public downloadMultipleDocuments() {
    const url = Constant.ROOT_API_V1
      .concat('/enterprises/')
      .concat(String(this.enterpriseIdSelected))
      .concat('/documents/stream');
    const docIdentifiers = StringUtil.concatIdentifiers(this.selectedDocuments);
    const formData = new FormData();
    formData.append('docIdentifiers', docIdentifiers);
    this.loadingDownload = true;
    this.documentService.getMultipleDocuments(url, formData).subscribe(next => {
      this.loadingDownload = false;
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      const today = LocalStorage.getTodayString();
      control.download = 'IOFESign-' + today + '-signed.zip';
      control.click();
      this.selectedDocuments = [];
    }, error => {
      this.loadingDownload = false;
      const title = this.translate.instant('TITLE.DOWNLOAD-DOCUMENTS');
      this.processError(title, error);
    });
  }

  public hasDeleteOption(document: any) {
    return this.isAllowedDelete(document) && document.personId === this.personId;
  }

  public openModalDelete(document: any) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-DOCUMENT');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteDocument(document);
      }
    });
  }

  public openModalDeleteBatch() {
    const documentIdentifiersToDeleted = this.filterDocumentToDeleted(this.selectedDocuments);
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.DELETE-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-DELETE-DOCUMENTS');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.deleteMultipleDocuments(documentIdentifiersToDeleted);
      }
    });
  }

  /**
   * Muestra en un modal el detalle del documento.
   */
  public openModalViewDetailDocument(document: Document) {
    const modalRef = this.modalService.open(ViewDocumentDetailComponent);
    modalRef.componentInstance.document = document;
  }

  private deleteDocument(document: any) {
    this.loadingSave = true;
    this.documentService.delete(document).subscribe(() => {
      this.loadingSave = false;
      this.loadDocuments(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, error => {
      this.loadingSave = false;
      const title = this.translate.instant('TITLE.DELETE-DOCUMENT');
      this.processError(title, error);
    });
  }

  public hasAuthority(code: string): boolean {
    return this.authenticationService.hasAuthority(code);
  }

  public openModalUnattend(document?: any) {
    let listDocuments: any[] = [];
    if (document) {
      listDocuments.push(document);
    } else {
      listDocuments = this.selectedDocuments;
    }
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.UNATTENDED-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-UNATTENDED-DOCUMENT');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.attendUnattend(listDocuments, DocumentState.FINISHED);
      }
    });
  }

  public addRemoveState(event, state: State) {
    this.loadingShowBy = true;
    if (DocumentState.MY_PENDINGS === state.id) {
      if (event.target.checked) {
        this.selectedStates = [];
        this.selectedStates.push(this.myPendingState);
      } else {
        this.pushDefaultStateValue4Adms();
      }
    } else {
      if (event.target.checked) {
        const index = this.selectedStates.findIndex(value => DocumentState.MY_PENDINGS === value.id);
        if (index !== -1) {
          this.selectedStates.splice(index, 1);
        }
        if (DocumentState.ALL === state.id) {
          for (const state1 of this.states) {
            if (!this.wasSelected2(state1)) {
              const clonedState = CloneTool.do(state1);
              this.selectedStates.push(clonedState);
            }
          }
        } else {
          this.selectedStates.push(state);
        }
      } else {
        if (DocumentState.ALL !== state.id && DocumentState.MY_PENDINGS !== state.id) {
          const index = this.selectedStates.findIndex(value => DocumentState.ALL === value.id);
          if (index !== -1) {
            this.selectedStates.splice(index, 1);
          }
        }
        if (this.selectedStates.length === 1) {
          this.loadingShowBy = false;
          event.target.checked = true;
          return;
        }
        if (DocumentState.ALL === state.id) {
          this.pushDefaultStateValue4NotAdms();
        } else {
          const index = this.getIndexOfState(state);
          this.selectedStates.splice(index, 1);
        }
      }
    }
    this.loadDocuments(Page.First);
  }

  public wasSelected2(state: State): boolean {
    if (DocumentState.ALL === state.id) {
      return this.selectedStates.length === this.states.length || this.otherWasSelected();
    }
    return this.selectedStates.find(value => value.id === state.id) !== undefined;
  }

  private pushDefaultStateValue4NotAdms() {
    this.selectedStates = [];
    this.selectedStates.push(this.myPendingState);
  }

  private pushDefaultStateValue4Adms() {
    this.selectedStates = [];
    this.states.forEach(state => {
      if (DocumentState.MY_PENDINGS !== state.id) {
        const state1 = CloneTool.do(state);
        this.selectedStates.push(state1);
      }
    });
  }

  private pushDefaultStateValue4Assistants() {
    this.selectedStates = [];
    this.selectedStates.push(this.pendingState);
  }

  private removeInnecesaryStateIds(identifiers: string) {
    return identifiers.split(',').filter(identifier => DocumentState.ALL !== +identifier).join(',');
  }

  private otherWasSelected() {
    const clonedStates: State[] = CloneTool.doList(this.states);
    for (let index = 0; index < clonedStates.length; index++) {
      const state = clonedStates[index];
      if (DocumentState.ALL === state.id) {
        clonedStates.splice(index, 1);
      }
    }
    for (const state of clonedStates) {
      if (!this.wasSelected2(state)) {
        return false;
      }
    }
    return true;
  }

  public getBadgeTextBy(document: any): string {
    if (DocumentState.CANCELED === document.stateId) {
      return 'badge-danger';
    } else if (DocumentState.MODIFIED === document.stateId) {
      return 'custom-badge-modified';
    } else {
      const commentsInfo: any[] = document._more.commentsInfo;
      if (commentsInfo) {
        const commentObserved = commentsInfo.find(value => Constant.OBSERVED === value.observed);
        if (commentObserved) {
          return 'badge-warning';
        } else {
          return 'badge-info';
        }
      }
    }
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.logout();
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private logout() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }

  public view(document: Document) {
    this.loadingSave = true;
    const url = Constant.ROOT_API_V1.concat('/documents/', String(document.id), '/traceability');
    this.documentService.get(url).subscribe(() => {
      this.loadingSave = false;
    }, error => {
      this.loadingSave = false;
      const title = this.translate.instant('TITLE.VIEW-TRACEABILITY');
      this.processError(title, error);
    });
  }

  /**
   * Verifica si el documento fue eliminado permanentemente
   */
  public wasDeleted(document: any): boolean {
    return DocumentState.PERMANENTLY_DELETED === document.stateId;
  }

  public openModalViewDocument(document: Document) {
    if (this.wasDeleted(document)) {
      this.openModalViewDetailDocument(document);
    } else {
      const modalRef = this.modalService.open(ViewDocumentComponent, {
        backdrop: 'static',
        size: 'xl'
      });
      modalRef.componentInstance.document = document;
    }
  }

  public openModalSendDocumentViaEmail(document: Document) {
    this.loading = true;
    const url = Constant.ROOT_API_V1 + '/enterprises/' + LocalStorage.getEnterpriseId() + '/documents/' + document.id + '/mailtemplateTypes/10/participantTypes/10/mailtemplates';
    this.mailtemplateService.get(url).subscribe((mailtemplate: Mailtemplate) => {
      this.loading = false;
      const modalRef = this.modalService.open(SendToEmailComponent, {
        backdrop: 'static',
        size: 'lg'
      });
      modalRef.componentInstance.document = document;
      modalRef.componentInstance.mailtemplate = mailtemplate;
      modalRef.result.then((result) => {
        if (InformType.Success === result) {
          this.loadDocuments(Page.Self);
          this.loadActualBalance();
        }
      });
    }, error => {
      this.loading = false;
      const title = this.translate.instant('TITLE.VIEW-TRACEABILITY');
      this.processError(title, error);
    });
  }

  public async openModalSignDocumentInternal(document: Document) {
    const documents: Document[] = [];
    documents.push(document);
    if (document.freelySignature) {
      this.validateAssignedEnable(documents);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (document._more.typeSignature === TypeSignature.ANYTHING) {
      this.openModalSignDocumentInternal5(documents);
    } else if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.openModalSignDocumentInternal2(documents);
    }
  }

  public async openModalSignInCloud(document: Document) {
    const documents: Document[] = [];
    documents.push(document);
    if (document.freelySignature) {
      this.validateAssignedEnable(documents);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.loadingSign = true;
      const url = Constant.ROOT_API_V1.concat('/uanataca/people/', String(LocalStorage.getPersonId()), '/documents/request/create');
      this.uanatacaService.post(url, documents).subscribe(value => {
        this.loadingSign = false;
        this.verifyAcceptTermToSignCloud(documents, value);
      }, error => {
        this.loadingSign = false;
        if (HttpStatusCode.FOUND === error.status) {
          Dialog.show(InformType.Warning, this.translate.instant('TITLE.ONESIGN-SIGNATURE'), error.error.message);
          return;
        }
        this.processError(this.translate.instant('TITLE.SIGNATURE'), error);
      });
    }
  }

  public async openModalSignBox(document: Document) {
    const documents: Document[] = [];
    documents.push(document);
    if (document.freelySignature) {
      this.validateAssignedEnable(documents);
      await new Promise<void[]>(resolve => setTimeout(resolve, 1000));
    }
    if (Constant.EMPTY_LIST === this.nameOfTheDocumentsBeingSigned.length) {
      this.loadingSign = true;
      this.openModalSignDocumentInternal4(documents);
      this.loadingSign = false;
    }
  }

  public completeDataSignCloud(document: Document) {
    this.loading = true;
    const workflowId = String(document.workflowId);
    const personUrl = Constant.ROOT_API_V1
      .concat('/workflows/')
      .concat(workflowId)
      .concat('/people/')
      .concat(String(document._more.personId));
    this.personService.get(personUrl).subscribe((next: any) => {
      if (next) {
        this.loading = false;
        this.openModalEditPerson(next, document);
      }
    }, error => {
      this.loading = false;
      const title = this.translate.instant('TITLE.PARTICIPANTS');
      this.processError(title, error);
    });
  }

  public openModalEditPerson(person: Person, document: Document) {
    const modalRef = this.modalService.open(AddEditPersonComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.personReceived = person;
    modalRef.componentInstance.purpose4Form = Constant.EDIT_ON_DOCS;
    modalRef.componentInstance.editOnSign = true;
    modalRef.componentInstance.addRubric = false;
    modalRef.componentInstance.typeSignature = person._more.typeSignature;
    modalRef.componentInstance.stampRubric = person._more.hasStampRubric;
    modalRef.componentInstance.hasImagesDocument = person._more.hasImagesDocument;
    modalRef.componentInstance.enterpriseIdSelected = LocalStorage.getEnterpriseIdView();
    modalRef.componentInstance.observation = document._more.observationSolcert;
    modalRef.componentInstance.stateId = document._more.stateSolcert;
    modalRef.componentInstance.typePerson = document._more.typePersonId;
    modalRef.componentInstance.documentId = document.id;
    modalRef.componentInstance.hasPowerValidity = person._more.hasPowerValidity;
    modalRef.componentInstance.hasRUCFile = person._more.hasRUCFile;
    modalRef.result.then((result) => {
      if (Constant.CANCEL !== result) {
        this.loadDocuments(Page.Self);
      }
    });
  }

  /**
   * Genera solicitud de validación de persona en el solcert
   */
  public generateRequestInSolcert(document: Document): void {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/personconfirmations');
    const formData = new FormData();
    formData.append('typePerson', String(document._more.typePersonId));
    formData.append('documentIds', String(document.id));
    this.personService.createRequestSolcert1(url, formData).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.REQUEST-SUCCESSFULLY-CREATED'), this.translate.instant('MESSAGE.SHORTLY-VALIDATE-INFORMATION'));
      this.loadDocuments(Page.Self);
      this.loading = false;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.CREATION-REQUEST'));
    });
  }

  public openModalSignDigitalDocumentInternal(documents: Document[]) {
    const modalRef = this.modalService.open(SignDocumentInternalComponent, {
      windowClass: 'my-class'
    });
    modalRef.componentInstance.documents = documents;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.DIGITAL-SIGNATURE'), this.translate.instant('MESSAGE.DIGITAL-SIGNATURE-COMPLETED'));
        this.loadDocuments(Page.Self);
        if (this.hasAuthority('own:view:document:10202')) {
          this.downloadAndSentDocument(documents[0]);
        }
      }
      if (InformType.Anything === result) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    });
  }

  public openModalSignDocumentInternal2(documents: Document[]) {
    const modalRef = this.modalService.open(SignDocumentInternalComponent, {
      windowClass: 'my-class'
    });
    modalRef.componentInstance.documents = documents;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.DIGITAL-SIGNATURE'), this.translate.instant('MESSAGE.DIGITAL-SIGNATURE-COMPLETED'));
        this.loadDocuments(Page.Self);
        if (this.hasAuthority('own:view:document:10202')) {
          this.downloadAndSentDocument(documents[0]);
        }
      }
      if (InformType.Anything === result) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    });
  }

  public openModalSignDocumentInternal5(documents: Document[]) {
    const modalRef = this.modalService.open(SignDocumentInternalComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.documents = documents;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.NOTIFY'), this.translate.instant('MESSAGE.NOTIFY-COMPLETED'));
        this.loadDocuments(Page.Self);
      }
      if (InformType.Anything === result) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    });
  }

  public openModalSignDocumentInternal4(documents: Document[]) {
    const modalRef = this.modalService.open(SignDocumentInternalComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.documents = documents;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, this.translate.instant('TITLE.REMOTE-SIGNATURE'), this.translate.instant('MESSAGE.REMOTE-SIGNATURE-COMPLETED'));
        this.loadDocuments(Page.Self);
        this.selectedDocuments = [];
        this.loadingSign = false;
        this.loadActualBalance();
      }
      if (InformType.Anything === result) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    });
  }

  public liberateParticipantAssignedToDocument(identifiers: string) {
    this.title = this.translate.instant('TITLE.DOCUMENTS');
    this.signService.getUUID(this.personId, identifiers).subscribe((next: any) => {
      const liberateParticipantsUrl = Constant.ROOT_API_V1
        .concat('/documents/')
        .concat(next.uuid)
        .concat('/people/')
        .concat(this.personId)
        .concat('/liberateAssigned');
      this.documentService.get(liberateParticipantsUrl).subscribe(() => {
      }, error => {
        this.processError(this.title, error);
      });
    }, error => {
      this.processError(this.title, error);
    });
  }

  public openModalSignDocumentInternal3(documents: Document[], uanatacaRequest: UanatacaRequest) {
    const modalRef = this.modalService.open(SignDocumentInternalComponent, {
      backdrop: 'static',
      size: 'xl'
    });
    modalRef.componentInstance.documents = documents;
    modalRef.componentInstance.uanatacaRequest = uanatacaRequest;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        Dialog.show(InformType.Success, 'OneSign', this.translate.instant('MESSAGE.ONE-SIGN-SIGNATURE-COMPLETED'));
        this.loadDocuments(Page.Self);
      }
      if (InformType.Anything === result) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    }, reason => {
      if (reason === ModalDismissReasons.ESC) {
        if (this.hasDocumentsWithFreelySignature(documents)) {
          const identifiers = StringUtil.concatIdentifiers(documents);
          this.liberateParticipantAssignedToDocument(identifiers);
        }
      }
    });
  }

  /**
   * Carga los datos necesarios para el 'Modificar un documento' y luego abre el modal para modificar el documento
   */
  public loadRequiredDataAndOpenModalModifyDocument(document: Document) {
    this.loading = true;
    const url = Constant.ROOT_API_V1.concat('/required-data?component=modify-document');
    this.applicationService.get(url).subscribe((next: any) => {
      this.loading = false;
      LocalStorage.setUpEmbeddedInfo(next);
      this.openModalModifyDocument(document);
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.title);
    });
  }

  public openModalModifyDocument(document: Document) {
    let modalRef;
    this.entityName = this.translate.instant('TITLE.DOCUMENTS');
    const workflow1 = this.workflows.find(workflow => workflow.id === document.workflowId);
    if (workflow1.dynamic) {
      modalRef = this.modalService.open(AddDocumentOneDynamicComponent, {backdrop: 'static', size: 'lg'});
    } else {
      modalRef = this.modalService.open(AddDocumentOneComponent, {backdrop: 'static', size: 'lg'});
    }
    modalRef.componentInstance.enterpriseIdSelected = workflow1.enterpriseId;
    modalRef.componentInstance.document2Modify = document;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadDocuments(Page.Self);
        Dialog.show(InformType.Success, this.entityName);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.entityName);
      }
    });
  }

  public openModalRevertDocument(document: Document) {
    const modalRef = this.modalService.open(ConfirmComponent);
    modalRef.componentInstance.title = this.translate.instant('TITLE.REVERT-DOCUMENT');
    modalRef.componentInstance.body = this.translate.instant('QUESTION.ARE-YOU-SURE-REVERT-DOCUMENT');
    modalRef.result.then((result) => {
      if (Response.Yes === result) {
        this.revertDocument(document);
      }
    });
  }

  private revertDocument(document: any) {
    this.loadingSave = true;
    const url = Constant.ROOT_API_V1
      .concat('/document/')
      .concat(document.id)
      .concat('/revert');
    this.documentService.revert(url).subscribe(() => {
      this.loadingSave = false;
      this.loadDocuments(Page.Self);
      Dialog.show(InformType.Success, this.entityName);
    }, error => {
      this.loadingSave = false;
      const title = this.translate.instant('TITLE.REVERT-DOCUMENT');
      this.processError(title, error);
    });
  }

  public wasModified(document: Document): boolean {
    return Constant.ACTIVE === document.active && DocumentState.MODIFIED === document.stateId;
  }

  public isPendingModification(document: Document): boolean {
    return Constant.ACTIVE === document.active && DocumentState.PENDING_MODIFICATION === document.stateId;
  }

  public hasModifyOption(document: Document): boolean {
    return !this.wasModified(document) && !this.wasCanceled(document) && !this.wasDeleted(document) && Constant.FINISHED === document.finished;
  }

  public hasRevertOption(document: Document) {
    return this.hasModifyOption(document) && this.isPendingModification(document);
  }

  public validateAssignedEnable(documents: Document[]) {
    const documentIds = StringUtil.concatIdentifiers(documents);
    this.nameOfTheDocumentsBeingSigned = [];
    const url = Constant.ROOT_API_V1
      .concat('/documents/')
      .concat(documentIds)
      .concat('/people/')
      .concat(String(this.personId))
      .concat('/validateIfExistsAssignedEnabled');
    this.documentService.validateAssigner(url).subscribe((next: any) => {
      if (next._embedded) {
        next._embedded.assigner.forEach(assigner1 => {
          const documentName = this.documents.find(document1 => document1.id === assigner1.documentId).subject;
          this.nameOfTheDocumentsBeingSigned.push(documentName);
        });
        const documentNames = this.nameOfTheDocumentsBeingSigned.join(',');
        if (next._embedded.assigner.length === 1) {
          Dialog.show(InformType.Info, this.translate.instant('TITLE.VALIDATE-ASSIGNED'), (String(this.translate.instant('MESSAGE.DOCUMENT-IS-SIGNED-BY-SOMEONE')), String(documentNames)));
          return;
        } else {
          Dialog.show(InformType.Info, this.translate.instant('TITLE.VALIDATE-ASSIGNED'), (String(this.translate.instant('MESSAGE.DOCUMENTS-ARE-SIGNED-BY-SOMEONE')), String(documentNames)));
          return;
        }
      } else {
        this.regularizeAssigned(documents);
      }
    }, error => {
      const title = this.translate.instant('TITLE.VALIDATE-ASSIGNED');
      this.processError(title, error);
    });
  }

  /*Permite eliminar documentos en lote*/
  deleteMultipleDocuments(documentsIdentifiers: any[]) {
    this.loadingSign = true;
    const title = this.translate.instant('TITLE.DELETE-DOCUMENT');
    if (documentsIdentifiers.length > 0) {
      this.documentService.deleteBatch(documentsIdentifiers).subscribe(next => {
        this.loadingSign = false;
        const message = this.translate.instant('MESSAGE.DOCUMENTS-DELETED-SUCCESSFULLY');
        Dialog.show(InformType.Success, title, String(next.totalDocumentsDeleted).concat(' ').concat(message));
        this.selectedDocuments = [];
        this.loadDocuments(Page.Self);
      }, error => {
        this.loadingSign = false;
        this.processError(title, error);
      });
    } else {
      this.loadingSign = false;
      this.selectedDocuments = [];
      Dialog.show(InformType.Info, title, this.translate.instant('MESSAGE.YOU-CANNOT-DELETED-DOCUMENTS'));
    }
  }

  public regularizeAssigned(documents: Document[]) {
    const documentIds = StringUtil.concatIdentifiers(documents);
    this.title = this.translate.instant('TITLE.DOCUMENTS');
    this.signService.getUUID(this.personId, documentIds).subscribe((next: any) => {
      const regularizeUrl = Constant.ROOT_API_V1
        .concat('/documents/')
        .concat(next.uuid)
        .concat('/people/')
        .concat(this.personId)
        .concat('/regularizeAssigned');
      this.documentService.get(regularizeUrl).subscribe(() => {
      }, error => {
        this.processError(this.title, error);
      });
    }, error => {
      this.processError(this.title, error);
    });
  }

  /**
   * Verifica si la empresa a la cual pertenece el usuario tiene activo el uso de monedas(IOFs)
   */
  get hasConfigBalance(): boolean {
    return LocalStorage.hasConfigBalance();
  }

  public hasDocumentsWithFreelySignature(documents: any): boolean {
    const documentsWithFreelySignature = documents.filter(documents2review => documents2review.freelySignature === true);
    return Constant.EMPTY_LIST !== documentsWithFreelySignature.length;
  }

  public clearFilters(): void {
    LocalStorage.removeItem('_searchDocument');
    this.searchFilters = new SearchDocument();
    this.showAdditionalFilters = false;
    this.subject = '';
    this.officialSubject = '';
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partnerSelected = this.partners[Constant.ZERO_INDEX];
      this.partnerId = this.partnerSelected.id;
      this.updateEnterprises();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.updateEnterprises();
    } else {
      this.updateWorkflows();
    }
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN) ||
        this.hasRole(this.ROLE_SUPERVISOR) || this.hasRole(this.ROLE_LITE_ADMIN)) {
      this.pushDefaultStateValue4Adms();
    } else if (this.hasRole(this.ROLE_ASSISTANT) || this.hasRole(this.ROLE_LITE_ASSISTANT)) {
      this.pushDefaultStateValue4Assistants();
    } else {
      this.pushDefaultStateValue4NotAdms();
    }
    if (this.hasAuthority('own:view:bar:limit:storage:500')) {
      this.getStorage();
    }
    this.refreshDocuments();
  }

  /**
   * Carga los estados en función a si tiene el permiso o no
   */
  loadStates(): void {
    this.states = LocalStorage.getStates();
    let index;
    this.states.forEach(state => {
      if (DocumentState.MODIFIED === state.id && !this.hasAuthority('own:document:modify:one2one')) {
        index = this.states.findIndex(value => DocumentState.MODIFIED === value.id);
        this.states.splice(index, 1);
      } else if (DocumentState.PENDING_MODIFICATION === state.id && !this.hasAuthority('own:document:modify:one2one')) {
        index = this.states.findIndex(value => DocumentState.PENDING_MODIFICATION === value.id);
        this.states.splice(index, 1);
      }
    });
  }

  /**
   * Obtiene total de espacio ocupado como almacenamiento en en función al permiso
   */
  private loadStorage() {
    if (this.hasAuthority('own:view:bar:limit:storage:500')) {
      this.getStorage();
      this.beginAutorefreshStorage();
    }
  }

  private getStorage() {
    if (!this.enterpriseIdSelected) {
      this.existLimitStorage = false;
      return;
    }
    this.storageService.getBy(this.enterpriseIdSelected).subscribe(response => {
      if (response) {
        this.existLimitStorage = true;
        this.enterpriseStorage = response;
      }
    }, () => {
      this.existLimitStorage = false;
      this.enterpriseStorage = {
        limitStorageBytes: 0,
        usedStorageBytes: 0
      };
    });
  }

  getProgress() {
    return ((Number(this.enterpriseStorage.usedStorageBytes) / Number(this.enterpriseStorage.limitStorageBytes)) * 100).toFixed(2);
  }

  /*Obenemos una lista de identificadores de los documentos a eliminar*/
  filterDocumentToDeleted(selectedDocuments: any[]) {
    const documentsIdentifiers = [];
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < selectedDocuments.length; index++) {
      const document = selectedDocuments[index];
      if (this.hasRole(Constant.ROLE_USER) && this.hasDeleteOption(document) && this.isAllowedDelete(document)) {
        documentsIdentifiers.push(document.id);
      } else if (!this.hasRole(Constant.ROLE_USER) && (this.hasDeleteOption(document) || this.isAllowedDelete(document))) {
        documentsIdentifiers.push(document.id);
      } else if (this.hasAuthority('own:view:document:10209')) {
        documentsIdentifiers.push(document.id);
      }
    }
    return documentsIdentifiers;
  }

  /**
   * habilitamos la opción de revision a los participantes del flujo, solo si es necesaria la revisión indicada en la conf. del flujo..
   */
  enabledReviewOption(document: any) {
    if (document._more.workflowMoreCondition) {
      return !document._more.reviewCompleted;
    }
    return true;
  }

  /**
   * Habilitamos la opción de firmar a los firmantes.
   */

  completedReview(document: any) {
    if (document._more.workflowMoreCondition) {
      const moreCondition = document._more.workflowMoreCondition;
      if (moreCondition.checkedMinReviewToFinalize) {
        return document._more.reviewCompleted;
      }
    }
    return true;
  }

  private getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.longitude = position.coords.longitude;
        this.latitude = position.coords.latitude;
        this.accuracy = position.coords.accuracy;
        console.log(position.coords);
      }, error => {
        this.longitude = null;
        this.latitude = null;
        this.accuracy = null;
      });
    }
  }

  private saveGeolocation(documents: Document[], personId: number, signatureType: string) {
    // tslint:disable-next-line:prefer-for-of
    for (let index = 0; index < documents.length; index++) {
      const date = new Date(Date.now());
      const documentId = documents[index].id;
      this.geolocation = this.setValueGeolocation(Number(documentId), personId);
      this.geolocation.signatureType = signatureType;
      this.geolocation.longTime = Date.now().toString();
      this.geolocation.timeStamp = date.toString();
      this.geolocation.timeZone = this.getGMT(date);
      this.geolocation.identification = Constant.AUTH_ACCOUNT;
      this.geolocationService.save(this.geolocation).subscribe(resp => {

      }, error => {
        Dialog.show(InformType.Danger, 'Localización', 'No se pudo guardar su ubicación.');
      });
    }
  }

  private setValueGeolocation(documentId: number, personId: number) {
    this.geolocation = new GeolocationIofesign();
    this.geolocation.latitude = String(this.latitude);
    this.geolocation.longitude = String(this.longitude);
    this.geolocation.accuracy = String(this.accuracy);
    this.geolocation.documentId = documentId;
    this.geolocation.personId = personId;
    this.geolocation.ip = LocalStorage.getIpAddress();
    return this.geolocation;
  }

  private getGMT(date: Date) {
    return date.toTimeString().split(' ')[1];
  }

  get limitStorageBytes() {
    return Number(this.enterpriseStorage.limitStorageBytes);
  }

  formatStorageUsed(storageUsedBytes: number = 0, decimals) {
    return ConvertBytes.format(storageUsedBytes, decimals);
  }

  formatStorageLimit(storageLimitBytes: number = 0, decimals) {
    return ConvertBytes.format(storageLimitBytes, decimals);
  }

  getUnitType(enterpriseStorage: any) {
    return LocalStorage.getStorageTypes().find(unitType => unitType.id === enterpriseStorage.storagetypeId).name;
  }

  private beginAutorefreshStorage() {
    this.storageInterval = setInterval(() => {
      if (this.existLimitStorage) {
        this.getStorage();
      }
    }, 2000);
  }

  get limitStorageSupered() {
    return (Number(this.enterpriseStorage.limitStorageBytes) / Number(this.enterpriseStorage.usedStorageBytes)) < 1;
  }

  get isOperationTypeDigitalSignatures(): boolean {
    return this.documents.filter(selectedDocument => selectedDocument._more.operationId === TypeSignature.DIGITAL).length !== 0;
  }

  get emptyResult(): boolean {
    return this.page.totalElements === 0;
  }

  get isEmptySelectedListPendingDocument() {
    return !this.isEmptySelectedList && this.selectedDocuments.filter(selectedDocument => selectedDocument.stateId === DocumentState.PENDING).length !== 0;
  }

  get hasDeleteOptionInBatch(): any {
    return !this.isEmptySelectedList && this.listDocumentRefresh().filter(selectedDocument => this.isAllowedDelete(selectedDocument) && this.permissionToDelete(selectedDocument)).length !== 0;
  }

  get isAllowedDeleteInBatch(): boolean {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.selectedDocuments.length; i++) {
      const document = this.selectedDocuments[i];
      return this.isAllowedDelete(document);
    }
    return false;
  }

  public permissionToDelete(selectedDocument) {
    if (this.hasRole(this.ROLE_ADMIN) || this.hasRole(this.ROLE_SUPERVISOR)) {
      return true;
    } else {
      return selectedDocument.personId === this.personId;
    }
  }

  /**
   * Se abre el modal para la aceptación de los terminos y condiciones.
   * @param document
   * @param cloudSignature
   * @private
   */
  private openAcceptTermsConditions(documents: any[], uanatacaRequest?: any) {
    const openModal = this.modalService.open(AcceptTermsConditionsComponent, {
      backdrop: 'static'
    });
    openModal.componentInstance.requestId = uanatacaRequest.moreAboutUanatacarequest.solcertRequestId;
    openModal.result.then((informType) => {
      if (informType === InformType.Success) {
        this.registerAcceptTerm(documents, uanatacaRequest);
      }
    });
  }

  /**
   * Este metodo verifica si el cliente acepto los terminos y condiciones para el documento,
   * @param document
   * @param typeSignature
   */
  verifyAcceptTermToSignCloud(documents: any[], uanatacaRequest?: any) {
    this.publicService.verifyAcceptTerm(uanatacaRequest.id).subscribe((next: any) => {
      if (Boolean(next.acceptTermCondition === 'true')) {
        this.openModalSignDocumentInternal3(documents, uanatacaRequest);
      } else {
        this.openAcceptTermsConditions(documents, uanatacaRequest);
      }
    }, () => {
      Dialog.show(InformType.Danger, this.title, 'Error, no se pudo verificar la aceptación de los terminos y condicones para este documento.');
    });
  }

  /**
   * Registramos los terminos y condicones aceptadas por el cliente.
   * @param document
   * @param typeSignature
   */
  registerAcceptTerm(documents: any[], uanatacaRequest?: any) {
    this.publicService.register(uanatacaRequest.id).subscribe((next: any) => {
      if (Boolean(next.acceptTermCondition === 'true')) {
        this.openModalSignDocumentInternal3(documents, uanatacaRequest);
      }
    }, () => {
      Dialog.show(InformType.Danger, this.title, 'Error, no se pudo registrar la aceptación de los terminos y condicones para este documento.');
    });
  }

  get activeAdditionalFilterCount(): number {
    return [this.searchFilters.documentNumber, this.searchFilters.fullName, this.searchFilters.ruc,
      this.searchFilters.businessName, this.searchFilters.uploader, this.searchFilters.dateFrom_,
      this.searchFilters.dateTo_].filter(Boolean).length;
  }

  public stateLabel(state: State): string {
    const key = 'SELECT.OPTIONS.' + state.shortDescription;
    const translated = this.translate.instant(key);
    return translated === key ? state.shortDescription : translated;
  }

  get hasAdditionalFilters(): boolean {
    return this.activeAdditionalFilterCount > 0;
  }

  get invalidDateRange(): boolean {
    const from = this.searchFilters.dateFrom_;
    const to = this.searchFilters.dateTo_;
    if (!from || !to) {
      return false;
    }
    const fromValue = from.year * 10000 + from.month * 100 + from.day;
    const toValue = to.year * 10000 + to.month * 100 + to.day;
    return fromValue > toValue;
  }

  private getAllWorkflowBy(enterpriseId: number): Observable<Workflow[]> {
    return this.workflowService.getWorkflowsExtraBy(enterpriseId).pipe(
      map((workflows: Workflow[]) => {
        const workflowsFilter = workflows.filter(workflow =>
          workflow.enterpriseId === enterpriseId &&
          workflow.ready2Use === Constant.READY_TO_USE);
        this.workflowDataService.setWorkflows(workflowsFilter);
        return workflowsFilter;
      })
    );
  }

  private getWorkflows(): Observable<Workflow[]> {
    if (this.hasRole(this.ROLE_SUPERADMIN) || this.hasRole(this.ROLE_PARTNER) || this.hasRole(this.ROLE_ADMIN)) {
      return this.getAllWorkflowBy(LocalStorage.getEnterpriseId());
    }
    return of(LocalStorage.getWorkflowsByPerson());
  }

  private wasObserved(document: any) {
    return DocumentState.OBSERVED === document.stateId;
  }
}
